import { deleteData, getData, postData, postFormData } from './config/ApiCalls';

import { apiSettings } from '../Settings';

export const addTender = async (data) => {
  try {
    const response = await postFormData(
      `${apiSettings.tender.addTender}`,
      data
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const awardTender = async (data) => {
  try {
    const response = await postData(`${apiSettings.tender.awardTender}`, data);
    return response;
  } catch (error) {
    return null;
  }
};

export const tenderAwardedTo = async (id = '') => {
  try {
    const response = await getData(`${apiSettings.tender.tenderAwardedTo(id)}`);
    return response;
  } catch (error) {
    return null;
  }
};

export const editTender = async (id, data) => {
  try {
    const response = await postFormData(
      `${apiSettings.tender.editTender(id)}`,
      data
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getTenderById = async (id = '') => {
  try {
    const response = await getData(`${apiSettings.tender.getTenderById(id)}`);
    return response;
  } catch (error) {
    return null;
  }
};

export const getTenderDetailById = async (id = '') => {
  try {
    const response = await getData(
      `${apiSettings.tender.getTenderDetailById(id)}`
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const deleteTenderById = async (id = '') => {
  try {
    const response = await deleteData(
      `${apiSettings.tender.deleteTenderById(id)}`
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const deleteTenderFile = async (id = '', path = '') => {
  try {
    const response = await deleteData(
      `${apiSettings.tender.deleteTenderFile(id, path)}`
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getTenderChangeHistory = async (id = '') => {
  try {
    const response = await getData(
      `${apiSettings.tender.getTenderChangeHistory(id)}`
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getTenders = async (page = 1) => {
  try {
    const response = await getData(`${apiSettings.tender.getTenders(page)}`);
    return response;
  } catch (error) {
    return null;
  }
};

export const openDownloadBidForTender = async (id = '', data) => {
  try {
    const response = await postData(
      `${apiSettings.tender.openDownloadBidForTender(id)}`,
      data
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getSupplierAllTender = async (
  page = 1,
  searchText = '',
  organization = '',
  publicationDateFrom = '',
  publicationDateTo = '',
  deadlieFrom = '',
  deadlieTo = '',
  procurementCategory = '',
  noticeType = '',
  location = ''
) => {
  try {
    const response = await getData(
      `${apiSettings.tender.getSupplierAllTender(
        page,
        searchText,
        organization,
        publicationDateFrom,
        publicationDateTo,
        deadlieFrom,
        deadlieTo,
        procurementCategory,
        noticeType,
        location
      )}`
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getMyTenders = async (page = 1) => {
  try {
    const response = await getData(`${apiSettings.tender.getMyTenders(page)}`);
    return response;
  } catch (error) {
    return null;
  }
};

export const getLatLng = async () => {
  try {
    const response = await getData(`${apiSettings.tender.getLatLng}`);
    return response;
  } catch (error) {
    return null;
  }
};
